import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxsModule } from '@ngxs/store';
import { UndoState } from './state/undo.state';

@NgModule({
  declarations: [],
  imports: [NgxsModule.forFeature([UndoState]), CommonModule],
})
export class UndoModule {}
